// @flow
import * as React from "react";
import "../dashboard-page.css";
import dashboard_ArrowIcon from "../../../../assets/icons/dashboard_ArrowIcon.svg";

export interface Props {
  text: string;
  icon: any;
  data: any;
  iconColor?: any;
  onViewDetails?: () => void;
}

const DashboardCard = (props: Props) => {
  const Icon = props.icon;
  return (
    <div className="dashboard-card">
      <div className="dashboard-card_top">
        <div
          className="dashboard-card_icon-circle"
          style={{ backgroundColor: "#FFF0F0" }}
        >
          <Icon
            className="dashboard-card_icon"
            style={{ color: props.iconColor }}
          />
        </div>
        <div className="dashboard-card_info">
          <div className="dashboard-card_data">{props.data}</div>
          <div className="dashboard-card_text">{props.text}</div>
        </div>
      </div>
      <hr className="dashed-break"></hr>
      <div
        className="dashboard-card_bottom"
        onClick={props.onViewDetails}
        style={{ cursor: "pointer" }}
      >
        <span>View details</span>
        <span className="dashboard-card_arrow" style={{ color: "#DB0001" }}>
          <img src={dashboard_ArrowIcon} alt="Arrow" />
        </span>
      </div>
    </div>
  );
};

export default DashboardCard;
